import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/components/ui/input-otp";
import { Button } from "@/components/ui/button";
import Heading from "@/components/Heading";
import Paragraph from "@/components/Paragraph";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
import Loading from "@/components/Loading";
import AlertBox from "@/components/AlertBox";
import axios from "axios";

function OtpVerify({ apiRoute }) {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  console.log(apiRoute);

  const phoneNumber = useSelector((state) => state.otpVerify.phoneNumber);
  console.log(phoneNumber);

  async function verify() {
    const otp = value;
    const data = {
      phoneNumber: phoneNumber,
      enteredOTP : otp
    }
    //console.log(otp);
    try {
      setLoading(true);
      const res = await axios({
        url: apiRoute,
        method: "post",
        data: data,
      });
      console.log(res.data);
      if (res.status >= 200 || res.status < 400) {
        navigate("/signup");
      }
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setErrorMessage(error?.response?.data?.error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="w-full flex justify-center items-center flex-col mt-[2rem] gap-5">
      {!success && (
        <AlertBox
          open={open}
          setOpen={setOpen}
          success={success}
          title={errorMessage}
        />
      )}
      <img src={logo} className="w-[10rem]" alt="" />
      <div className="w-full flex justify-center items-center flex-col mt-[8rem]">
        <section className="mb-5">
          <Heading>OTP Verification</Heading>
          <Paragraph className={"text-slate-600"}>
            Please enter the one-time-password that we have sent to{" "}
            <span className="underline">{phoneNumber}</span>
          </Paragraph>
        </section>
        <InputOTP
          maxLength={6}
          value={value}
          onChange={(value) => setValue(value)}
        >
          <InputOTPGroup>
            <InputOTPSlot index={0} className="w-[3rem] h-[3rem] text-[18px]" />
            <InputOTPSlot index={1} className="w-[3rem] h-[3rem] text-[18px]" />
            <InputOTPSlot index={2} className="w-[3rem] h-[3rem] text-[18px]" />
            <InputOTPSlot index={3} className="w-[3rem] h-[3rem] text-[18px]" />
            <InputOTPSlot index={4} className="w-[3rem] h-[3rem] text-[18px]" />
            <InputOTPSlot index={5} className="w-[3rem] h-[3rem] text-[18px]" />
          </InputOTPGroup>
        </InputOTP>
      </div>
      {loading === true ? (
        <Loading color={"bg-sky-500"} />
      ) : (
        <Button onClick={verify}>Verify OTP</Button>
      )}
    </div>
  );
}

export default OtpVerify;
